import { callApi } from './ApiClient';

const postGenerate = (data, dispatch) => {
  return callApi('POST', `/letter-auto-generate/generate`, data, dispatch);
}

export const LetterAutoGenerateApi = {
  postGenerate,
};



// WEBPACK FOOTER //
// ./src/redux/api/LetterAutoGenerateApi.js